/** A business key — monospace, never a surrogate id. Optionally copyable. */
import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { cn } from "@/lib/utils";

export interface CodeTagProps {
  value: string;
  copyable?: boolean;
  className?: string;
}

export function CodeTag({ value, copyable = false, className }: CodeTagProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      /* Clipboard denied: the value is on screen and selectable anyway. */
    }
  };

  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      <span className="type-key">{value}</span>
      {copyable && (
        <button
          type="button"
          onClick={copy}
          aria-label={copied ? `Copied ${value}` : `Copy ${value}`}
          className="text-muted-foreground hover:text-foreground focus-visible:ring-ring rounded-[var(--radius-sm)] p-0.5 focus-visible:ring-2 focus-visible:outline-none"
        >
          {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
        </button>
      )}
    </span>
  );
}
